import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import FirmaForm from './FirmaForm';
import { storeActions } from '../../store/configureStore';
import OptionModal from '../common/OptionModal';

export class EditFirmaPage extends React.Component {
  state = {
    isOpen: false,
    modalContent: 'remove_confirm',
    btnEnabled: true,
  };

  handleOpenModal = () => {
    this.setState(() => ({
      isOpen: true,
    }));
  };

  handleCloseModal = () => {
    this.setState({ isOpen: false });
  };

  onSubmit = async (firma) => {
    await this.props.startEditFirma(this.props.firma.id, firma);
    this.props.history.push(`/utenti`);
  };
  onRemove = () => {
    this.props.startRemoveFirma({ id: this.props.firma.id });
    this.props.history.push('/utenti');
  };

  render() {
    if (!this.props.firma) {
      this.props.history.push('/utenti');
      return <div>Loading...</div>;
    }
    return (
      <div>
        <div>
          <div className='container'>
            <h1>{this.props.t('Modifica dati azienda')}</h1>
          </div>
        </div>
        <div className='container'>
          <OptionModal
            isOpen={this.state.isOpen}
            contentLabel={'remove'}
            modalContent={this.props.t(this.state.modalContent)}
            onCancel={this.handleCloseModal}
            onConfirm={this.onRemove}
            btnEnabled={this.state.btnEnabled}
          />
          <FirmaForm firma={this.props.firma} onSubmit={this.onSubmit} />
          <button
            className='btn-floating red margine-basso'
            onClick={this.handleOpenModal}
          >
            <i className='material-icons'>delete</i>
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  firma: state.firma.find((firma) => firma.id === props.match.params.id),
});

const mapDispatchToProps = (dispatch) => ({
  startEditFirma: (id, firma) =>
    dispatch(
      storeActions
        .find((action) => action.label === 'firma')
        .startEditAction(id, firma)
    ),
  startRemoveFirma: (data) =>
    dispatch(
      storeActions
        .find((action) => action.label === 'firma')
        .startRemoveAction(data)
    ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(EditFirmaPage));



// WEBPACK FOOTER //
// ./src/components/firma/EditFirmaPage.js